// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"ExpiredNotification_container__26nKy","link":"ExpiredNotification_link__2MAJA"};